import UserContract from './contract'
export default UserContract
